


















import Vue from "vue";
import { Model, Prop, Component, Ref, Watch } from "vue-property-decorator";

@Component
export default class ShareDialogTypeOptions extends Vue {

    // some input element with ref="linkField" 
    // @Ref()
    // private linkField: HTMLInputElement;

    @Model('updated:value', {type: String, default: 'FORM'})
    value: string;

    get viewType(): string {
        return this.value;
    }

    set viewType(val: string) {
        this.$emit('updated:value', val);
    }


}
